/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S5_No_Tracking_PrefixInputs */

const tr_cerez_s5_no_tracking_prefix = /** @type {(inputs: Cerez_S5_No_Tracking_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platform'da Google Analytics, Facebook Pixel veya benzeri üçüncü taraf izleme araçları`)
};

const en_cerez_s5_no_tracking_prefix = /** @type {(inputs: Cerez_S5_No_Tracking_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On the Platform, third party tracking tools such as Google Analytics, Facebook Pixel or similar`)
};

const de_cerez_s5_no_tracking_prefix = /** @type {(inputs: Cerez_S5_No_Tracking_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking-Werkzeuge Dritter wie Google Analytics, Facebook Pixel oder ähnliche auf der Plattform`)
};

const ru_cerez_s5_no_tracking_prefix = /** @type {(inputs: Cerez_S5_No_Tracking_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сторонние инструменты отслеживания на Платформе, такие как Google Analytics, Facebook Pixel и аналогичные,`)
};

/**
* | output |
* | --- |
* | "On the Platform, third party tracking tools such as Google Analytics, Facebook Pixel or similar" |
*
* @param {Cerez_S5_No_Tracking_PrefixInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s5_no_tracking_prefix = /** @type {((inputs?: Cerez_S5_No_Tracking_PrefixInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S5_No_Tracking_PrefixInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s5_no_tracking_prefix(inputs)
	if (locale === "de") return de_cerez_s5_no_tracking_prefix(inputs)
	if (locale === "ru") return ru_cerez_s5_no_tracking_prefix(inputs)
	return tr_cerez_s5_no_tracking_prefix(inputs)
});